import { useState } from 'react';
import { Ship, ArrowUpRight } from 'lucide-react';
import { api } from '@/lib/api';

export default function Login({ onLogin }) {
  const [email, setEmail] = useState('corporate.hr@fairwayhr.io');
  const [password, setPassword] = useState('HarborHR2026!');
  const [error, setError] = useState('');

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    try {
      const user = await api('/auth/login', { method: 'POST', body: JSON.stringify({ email, password }) });
      onLogin(user);
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <main className="login-page">
      <div className="login-art">
        <div className="brand"><span className="brand-mark"><Ship size={18} /></span> FairWay <em>HR</em></div>
        <div className="login-quote">
          <p>Clear. Consistent. Compliant. Fair.</p>
        </div>
      </div>
      <form className="login-form" onSubmit={submit}>
        <div className="login-kicker">SECURE WORKSPACE</div>
        <h1>Welcome aboard.</h1>
        <p className="muted">Sign in to manage crew relations across your fleet.</p>
        <label>Email address
          <input data-testid="login-email-input" value={email} onChange={(e) => setEmail(e.target.value)} type="email" required />
        </label>
        <label>Password
          <input data-testid="login-password-input" value={password} onChange={(e) => setPassword(e.target.value)} type="password" required />
        </label>
        {error && <div data-testid="login-error" className="error">{error}</div>}
        <button data-testid="login-submit-button" className="primary-btn" type="submit">
          Enter workspace <ArrowUpRight size={16} />
        </button>
        <small className="muted">Demo access is prefilled for your review.</small>
      </form>
    </main>
  );
}
